import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { shelfNameShape } from 'app/shapes/search';
import ShelfLink from '../../shelves/ShelfLink';

import './ShelfAvailabilityTitle.scss';

export class ShelfAvailabilityTitle extends React.PureComponent {
  getShelfUrl() {
    const { userId, shelfName } = this.props;
    return `/v2/users/${userId}/shelves/${shelfName}`;
  }

  renderShelfTitleContent() {
    const { shelfName } = this.props;

    return (
      shelfName && (
        <h1 className="shelf-title">
          <FormattedMessage id={`Search.shelfTitle.${shelfName}`} />
        </h1>
      )
    );
  }

  render() {
    const { userId, shelfName } = this.props;
    return (
      <div className="row cp-shelf-availability-title">
        <div className="col-12 col-xs-12 shelf-availability-title-block" aria-atomic="true">
          <div className="shelf-title-header">
            {this.renderShelfTitleContent()}
            <ShelfLink userId={userId} shelfName={shelfName}>
              <FormattedMessage id="back_to_shelf_link_text" />
            </ShelfLink>
          </div>
        </div>
      </div>
    );
  }
}

ShelfAvailabilityTitle.propTypes = {
  userId: PropTypes.number.isRequired,
  shelfName: shelfNameShape.isRequired
};

export default ShelfAvailabilityTitle;
